import { useApolloClient } from '@apollo/client'
import { GatsbyLinkProps, Link, navigate } from 'gatsby'
import { forwardRef } from 'react'

import { BreadcrumbsNavigation, Search } from '@karakuri-web/faq-component'
import { Breadcrumb, BreadcrumbType, CategorySub, Hierarchy } from '@karakuri-web/faq-type'

import { EventTrigger } from '../utils/event-trigger'

import { GQL_SEARCHED_FAQ, GQL_SEARCH_FAQ } from './graphql'
import { Data } from './interface'

interface Props {
  botId: string
  tenantId?: string
  breadcrumb: Breadcrumb
  breadcrumbType?: BreadcrumbType | null
  relatedCategories?: CategorySub[]
  hierarchies: Hierarchy[]
  searchWaitMs: number
  topTitle: string
  searchType: string
  data: Data
}
export function NaviWidget({
  botId,
  tenantId,
  hierarchies,
  breadcrumb,
  breadcrumbType,
  relatedCategories = [],
  searchWaitMs,
  topTitle,
  searchType,
  data,
}: Props) {
  const client = useApolloClient()
  const handleSearched = (inputValue: string, result: any[]) => {
    EventTrigger.search(inputValue, result)
    client.mutate({
      mutation: GQL_SEARCHED_FAQ,
      variables: {
        botId,
        tenantId,
        text: inputValue,
      },
    })
  }
  const LinkComponent = forwardRef<HTMLAnchorElement, GatsbyLinkProps<Record<string, unknown>>>(
    function LinkComponent(props, ref) {
      const found = hierarchies.findIndex(h => h.link === props.to)
      const h = hierarchies.slice(0, found)
      const newProps: Omit<GatsbyLinkProps<Record<string, unknown>>, 'to'> = {}
      if (h.length > 0) {
        newProps.state = { hierarchies: h }
      }
      return <Link ref={ref as any} {...{ ...props, ...newProps }} />
    }
  )

  return (
    <div className="faq-navigation">
      <BreadcrumbsNavigation
        tags={[
          { link: '/', title: topTitle },
          ...relatedCategories
            .filter(x => !x.isParent)
            .map(c => {
              const title = c.title || ''
              return { link: `/category/${c.id}`, title }
            }),
        ]}
        LinkComponent={LinkComponent}
        breadcrumbType={breadcrumbType}
        breadcrumb={breadcrumb}
        relatedCategories={relatedCategories}
        topTitle={topTitle}
      />

      <Search
        onClick={navigate}
        onSearched={handleSearched}
        searchWaitMs={searchWaitMs}
        search={inputValue =>
          client.query({
            query: GQL_SEARCH_FAQ,
            variables: { botId, inputValue: inputValue || '', searchType, tenantId },
          })
        }
        resultMessage={{
          success: data.settingYaml?.words?.search?.resultMessage?.success || undefined,
          error: data.settingYaml?.words?.search?.resultMessage?.error || undefined,
        }}
      />
    </div>
  )
}
